import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import _toArray from "@babel/runtime-corejs2/helpers/toArray";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import * as React from 'react';
import chunk from 'lodash/chunk';
import flatten from 'lodash/flatten';
/**
 * An utility function that looks for tag-value pairs inside a string
 * and replace them with the result of a function in a result of type React.Element<any>.
 */
var mapTags = function mapTags(pattern, tagsFn) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  // Find the tags in the pattern.
  var _pattern$split = pattern.split(/\[\[([^\]]*)\]\]/),
    _pattern$split2 = _toArray(_pattern$split),
    firstText = _pattern$split2[0],
    pairs = _pattern$split2.slice(1);

  // Group the elements by chunks of 2: [tagText, text]
  var chunks = chunk(pairs, 2);

  // Collect the tags' key-value pairs into an object.
  var tags = chunks.reduce(function (acc, _ref, index) {
    var _ref2 = _slicedToArray(_ref, 1),
      tagText = _ref2[0];
    var _tagText$split = tagText.split(':'),
      _tagText$split2 = _slicedToArray(_tagText$split, 2),
      key = _tagText$split2[0],
      value = _tagText$split2[1];
    acc[key] = value;
    chunks[index][0] = key; // [side effect] this is reused below.
    return acc;
  }, {});

  // Get the transformed tags.
  var transformedTags = tagsFn(tags);

  // Are all the keys in the transformedTags present in the tags?
  // If no: the translation is missing some keys, we display an error for those keys.
  var missingKeys = _Object$keys(transformedTags).filter(function (key) {
    return !(key in tags);
  });
  if (missingKeys.length > 0) {
    // TODO: log an error to the console and to Sentry
  }

  // Are all the keys in the tags present in the transformedTags?
  // If no: the translation contains unhandled keys, we display an error for those keys.
  var unhandledKeys = _Object$keys(tags).filter(function (key) {
    return !(key in transformedTags);
  });
  if (unhandledKeys.length > 0) {
    // TODO: log an error to the console and to Sentry
  }

  // We combine the tags and transformedTags so that the tags are overwritten by the transformedTags.
  // $FlowFixMe[incompatible-type]: FIXME: bunch of errors that does not look expected
  var combinedTags = _objectSpread(_objectSpread({}, tags), transformedTags);

  // Select the function to apply on the text segments.
  var textFn = options.withHTML ? function (text) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-danger
      React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: text
        }
      })
    );
  } : options.textFn || function (text) {
    return text;
  };

  // Combine everything back together.
  return /*#__PURE__*/React.createElement.apply(React, [React.Fragment, null].concat(_toConsumableArray([textFn(firstText)].concat(_toConsumableArray(flatten(chunks.map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      tagKey = _ref4[0],
      text = _ref4[1];
    return [combinedTags[tagKey], textFn(text)];
  })))).filter(Boolean))));
};
export default mapTags;